const ERROR_MESSAGE = Object.freeze({
  actionFailedTransKey: 'composite.transactionErrorMessages.actionFailed',
  chargeInPersonTransKey: 'composite.transactionErrorMessages.chargeInPerson',
  txCreateTransKey: 'composite.transactionErrorMessages.txCreate',
});

// noinspection JSUnusedGlobalSymbols
export default ERROR_MESSAGE;
